// The FPS counter (stats.js) in the corner of the game, shown only while the "Show FPS counter" setting is on.
import {PlayerSettings} from "./settings";

interface StatsLike { domElement: HTMLElement; update(): void; }

let counter: StatsLike | null = null;
let unsubscribe: (() => void) | null = null;

function apply(show: boolean) {
    if (counter) counter.domElement.style.display = show ? "" : "none";
}

export const FpsCounter = {
    /** Takes over a stats.js counter: hides it unless the setting is on, and follows the setting from then on. */
    bind(stats: StatsLike) {
        if (unsubscribe) unsubscribe();
        counter = stats;
        apply(PlayerSettings.get().showFps);
        unsubscribe = PlayerSettings.subscribe(s => apply(s.showFps));
    },
    /** Once per frame; skips the counter's work while it is hidden. */
    update() {
        if (counter && PlayerSettings.get().showFps) counter.update();
    },
    visible: () => !!counter && counter.domElement.style.display !== "none",
};
